import { PageRecord } from "../../recordDefinition.types";

export const isActiveContact = (record: PageRecord) => record.statecode === 0;

/** The `{ id, name }` shape the shared contact modals expect. */
export const contactModalState = (record: PageRecord) => ({
  id: record.id,
  name: `${record.firstname ?? ""} ${record.lastname ?? ""}`.trim(),
});
